import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

// Only a real failure reaches this action: a 404 (no configuration) is a success case, handled by
// `identityProviderFetched` with a `null` payload instead.
export type IdentityProviderFetchFailedAction = {
	type: 'IDENTITY_PROVIDER_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): IdentityProviderFetchFailedAction => ({
	type: 'IDENTITY_PROVIDER_FETCH_FAILED',
	payload,
});
